import React, { useState, useEffect } from 'react';
import { FaUsers, FaLightbulb, FaHandshake } from 'react-icons/fa';
import { FiAward, FiClock, FiDollarSign } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const Careers = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    resume: null,
    coverLetter: '',
  });
  const [showJobDetailsPopup, setShowJobDetailsPopup] = useState(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState(null);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 8000);
    
    return () => clearInterval(interval);
  }, []);

  const particlesInit = async (main) => {
    await loadSlim(main);
  };

  const jobOpenings = [
    {
      id: 1,
      title: 'Development Engineer',
      type: 'Full-Time',
      location: 'Irvine, CA',
      department: 'Engineering',
      description: 'Active Involvement in Requirements Gathering & analysis, Project Estimation, Design documentation, and application development. Design, develop, test, and code for various business applications and utilize all cutting-edge technologies.',
      responsibilities: [
        'Active Involvement in Requirements Gathering & analysis, Project Estimation, Design documentation, and application development. Design, develop, test, and code for various business applications and utilize all cutting-edge technologies. Hands on experience in implementing SAFE framework, Agile Scrum & Waterfall methodology.',
        'Work on multiple mid-sized projects in a fast-paced, dynamic environment. Work efficiently using source control and integration tools like Git, Tortoise SVN and Jenkins.',
        'Use various tools and IDEs for development and design and Work with variety of Web and applications servers across multiple projects.',
        'This position requires a master degree in Computer Science, Software or Electrical/Electronics Engineering or related, or a BS and 5 years of experience.',
       
      ],
    },
    {
      id: 2,
      title: 'SAP MM/CRM Consultant',
      type: 'Full-Time',
      location: 'Irvine, CA',
      department: 'Engineering',
      description: 'Working as a Software Consultant and leading the onshore team to deliver the implemented software features and updates.',
      responsibilities: [
        'Working as a Software Consultant and leading the onshore team to deliver the implemented software features and updates. Collaborating with business stakeholders to design and enhance user experience on various CRM platform.',
        'Ability to advice businesses on best practices in the SAP and CRM cloud while ensuring the solution meets business needs.',
        'Working collaboratively with Development team to build functionalities. Building custom application based on the knowledge of CRM cloud platform processes.',
        'This position requires an associate degree and three years of experience as an SAP MM/CRM consultant.',
       
      ],
    },
    {
      id: 3,
      title: 'Software Developers – Multiple Openings',
      type: 'Full-Time',
      location: 'Irvine, CA',
      department: 'Engineering',
      description: 'Cognifyar Technologies needs professionals: Work using Java, ASP.Net, Python, Angular.JS, SQL, XML, Oracle, Web Services, Restful Services & MVC.',
      responsibilities: [
        'Cognifyar Technologies needs professionals: Work using Java, ASP.Net, Python, Angular.JS, SQL, XML, Oracle, Web Services, Restful Services & MVC.',
        'Req: Bachelor’s + 5 yr exp.',
        'Wages: $184,558/yr.',
        'Relocate to unanticipated site. No Int’l/Nat’l travel.',
        
      ],
    },
    {
      id: 4,
      title: 'Computer and Information Systems Managers/Project Manager – Multiple Openings',
      type: 'Full-Time',
      location: 'Irvine, CA',
      department: 'Engineering',
      description: 'Cognifyar Technologies needs professionals: Plan and manage IT projects, coordinate teams, oversee software deployments, and ensure timely project delivery.',
      responsibilities: [
        'Cognifyar Technologies needs professionals: Plan and manage IT projects, coordinate teams, oversee software deployments, and ensure timely project delivery.',
        'Req: Bachelor’s + 5 yr exp.',
        'Wages: $237,141/yr.',
        'Relocate to unanticipated site. No Int’l/Nat’l travel.',
        
      ],
    },
  ];

  const benefits = [
    { icon: <FiAward />, title: 'Career Growth', description: 'Structured promotion paths and leadership training programs' },
    { icon: <FiClock />, title: 'Flexible Hours', description: 'Results-oriented work environment with flexible scheduling' },
    { icon: <FiDollarSign />, title: 'Competitive Pay', description: 'Industry-leading compensation with performance bonuses' },
    { icon: <FaUsers />, title: 'Team Culture', description: 'Collaborative environment with regular team-building events' },
    { icon: <FaLightbulb />, title: 'Innovation Time', description: 'Dedicated time for personal projects and Research & Development ' },
    { icon: <FaHandshake />, title: 'Client Exposure', description: 'Direct interaction with high-profile clients and projects' },
  ];

  const testimonials = [
    {
    quote: "Every day brings new opportunities to learn, grow, and make a meaningful impact in the industry."
  },
    {
      quote: "The collaborative environment and commitment to innovation here creates the perfect conditions for professional growth and breakthrough solutions."
    },
    {
      quote: "Working with cutting-edge technologies on meaningful projects makes every day both challenging and rewarding."
    },
    {
      quote: "The culture of excellence combined with genuine teamwork makes this an exceptional place to build a career."
    },
   
    {
      quote: "Where passion meets purpose—delivering solutions that make a difference for businesses and communities."
    }
   
  ];

  const filteredJobs = activeTab === 'all' 
    ? jobOpenings 
    : jobOpenings.filter(job => job.type === activeTab || job.department === activeTab);

  const handleApplyClick = (job) => {
    setSelectedJob(job);
    setShowApplicationForm(true);
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Application submitted:', { job: selectedJob, applicant: formData });
    alert(`Thank you for applying to ${selectedJob.title}! We'll review your application.`);
    setShowApplicationForm(false);
    setFormData({
      name: '',
      email: '',
      phone: '',
      resume: null,
      coverLetter: '',
    });
  };

  const handleReadMoreClick = (job) => {
    setSelectedJobDetails(job);
    setShowJobDetailsPopup(true);
  };

  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const staggerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 1 }
    }
  };

  return (
    <div className="careers-page">
      {/* Animated Background Particles */}
      <div className="particles-container">
        <Particles
          id="tsparticles"
          init={particlesInit}
          options={{
            fullScreen: { enable: false, zIndex: 0 },
            particles: {
              number: { value: 30, density: { enable: true, value_area: 800 } },
              color: { value: "#00ff99" },
              shape: { type: "circle" },
              opacity: { value: 0.5, random: true },
              size: { value: 3, random: true },
              line_linked: { enable: true, distance: 150, color: "#00ff99", opacity: 0.2, width: 1 },
              move: { enable: true, speed: 2, direction: "none", random: true, straight: false, out_mode: "out" }
            },
            interactivity: {
              events: {
                onhover: { enable: true, mode: "repulse" }
              }
            }
          }}
        />
      </div>

      {/* Hero Section */}
      <motion.section 
        className="careers-hero"
        initial="hidden"
        animate="visible"
        variants={fadeInVariants}
      >
        <div className="container">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Build the Future With Us
          </motion.h1>
          <motion.p 
            className="subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            We're assembling an exceptional team to solve complex challenges through innovation and technology. 
            Join us to create products that redefine industries and improve how people work and live.
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
            className="hero-cta"
          >
            <button 
           className="shadow-rotating-button"
              onClick={() => document.querySelector('.job-openings').scrollIntoView({ behavior: 'smooth' })}
            >
              Explore Opportunities
            </button>
          </motion.div>
        </div>
      </motion.section>

      {/* Job Openings Section */}
      <motion.section 
        className="job-openings"
        id="job-openings"
        initial="hidden"
        whileInView="visible"
        variants={sectionVariants}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="container">
          <motion.div className="section-header" variants={itemVariants}>
            <h2>Current Openings</h2>
            <div className="job-filters">
              <button 
                className={activeTab === 'all' ? 'active' : ''}
                onClick={() => setActiveTab('all')}
              >
                All Jobs
              </button>
              <button 
                className={activeTab === 'Full-Time' ? 'active' : ''}
                onClick={() => setActiveTab('Full-Time')}
              >
                Full-time
              </button>
              <button 
                className={activeTab === 'contract' ? 'active' : ''}
                onClick={() => setActiveTab('contract')}
              >
                Contract
              </button>
            </div>
          </motion.div>

          <motion.div 
  className="job-listings"
  key={activeTab} // Add this line
  variants={staggerVariants}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-100px" }}
>
            {filteredJobs.length > 0 ? (
              filteredJobs.map((job, index) => (
                <motion.div 
                  key={job.id} 
                  className="job-card"
                  variants={itemVariants}
                  whileHover={{ y: -5 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="job-info">
                    <h3>{job.title}</h3>
                    <div className="job-meta">
                      <span className="job-type">{job.type.replace('-', ' ')}</span>
                      <span className="job-location">{job.location}</span>
                    </div>
                    <p className="job-description">{job.description}</p>
                    
                    <button 
                      className="read-more-button"
                      onClick={() => handleReadMoreClick(job)}
                    >
                      Read More
                    </button>
                  </div>
                  <button 
                    className="apply-button"
                    onClick={() => window.location.href = 'mailto:Divya@cognifiyar.com'}
                  >
                    Apply Now
                  </button>
                </motion.div>
              ))
            ) : (
              <div className="no-jobs">
                <p>No current openings match your filters. Check back later or <a href="#subscribe">subscribe to job alerts</a>.</p>
              </div>
            )}
          </motion.div>
        </div>
      </motion.section>

      {/* Benefits Section */}
      <motion.section 
        className="benefits-section"
        initial="hidden"
        whileInView="visible"
        variants={sectionVariants}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="container">
          <motion.h2 variants={itemVariants}>Why Join Us?</motion.h2>
          <motion.p 
            className="section-intro"
            variants={itemVariants}
          >
            We invest in our team's success with comprehensive benefits and growth opportunities.
          </motion.p>
          
          <motion.div 
            className="benefits-grid"
            variants={staggerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {benefits.map((benefit, index) => (
              <motion.div 
                key={index} 
                className="benefit-card"
                variants={itemVariants}
                // whileHover={{ y: -10 }}
              >
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.section>

      {/* Testimonials Section */}
      <motion.section 
        className="testimonials-section"
        initial="hidden"
        whileInView="visible"
        variants={sectionVariants}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="container">
          <motion.h2 variants={itemVariants}>Hear From Our Team</motion.h2>
          
          <div className="testimonials-container">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTestimonial}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
                className="testimonial"
              >
                <div className="quote-icon">"</div>
                <p className="quote-text">{testimonials[activeTestimonial].quote}</p>
                <div className="author-info">
                  <div className="author-name">{testimonials[activeTestimonial].author}</div>
                  <div className="author-role">{testimonials[activeTestimonial].role}</div>
                </div>
              </motion.div>
            </AnimatePresence>
            
            <div className="testimonial-nav">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`testimonial-dot ${index === activeTestimonial ? 'active' : ''}`}
                  onClick={() => setActiveTestimonial(index)}
                  aria-label={`View testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </motion.section>

  {/* CTA Section */}
  <motion.section 
        className="cta-section"
        initial="hidden"
        whileInView="visible"
        variants={sectionVariants}
        viewport={{ once: true, margin: "-100px" }}
      >
        <div className="container">
          <motion.div 
            className="cta-content"
            variants={staggerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <motion.h2 variants={itemVariants}>Ready to Grow With Us?</motion.h2>
            <motion.p variants={itemVariants}>
              Even if you don't see the perfect role today, we're always interested in connecting with exceptional talent.
            </motion.p>
            <motion.div variants={itemVariants}>
              <button 
              className="shadow-rotating-button"
                onClick={() => window.location.href = 'mailto:Divya@cognifiyar.com'}
              >
                Get in Touch
              </button>
            </motion.div>
          </motion.div>
        </div>
      </motion.section>
    
      {/* Application Modal */}
      <AnimatePresence>
        {showApplicationForm && (
          <motion.div 
            className="application-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div 
              className="modal-content"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
            >
              <button 
                className="close-button"
                onClick={() => setShowApplicationForm(false)}
              >
                &times;
              </button>
              
              <h2>Apply for {selectedJob.title}</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name*</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email*</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phone">Phone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="resume">Resume/CV*</label>
                  <input
                    type="file"
                    id="resume"
                    name="resume"
                    accept=".pdf,.doc,.docx"
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="coverLetter">Cover Letter</label>
                  <textarea
                    id="coverLetter"
                    name="coverLetter"
                    value={formData.coverLetter}
                    onChange={handleInputChange}
                    placeholder="Tell us why you're a great fit for this role..."
                    rows="5"
                  />
                </div>
                
                <button type="submit" className="submit-application">
                  Submit Application
                </button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Job Details Modal */}
      <AnimatePresence>
        {showJobDetailsPopup && selectedJobDetails && (
          <motion.div 
            className="job-details-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div 
              className="modal-content"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
            >
              <button 
                className="close-button"
                onClick={() => setShowJobDetailsPopup(false)}
              >
                &times;
              </button>
              
              <h2>{selectedJobDetails.title}</h2>
              <div className="job-meta">
                <span className="job-type">{selectedJobDetails.type.replace('-', ' ')}</span>
                <span className="job-location">{selectedJobDetails.location}</span>
              </div>
              
              <div className="responsibilities">
                <h3>Duties Include:</h3>
                <ul>
                  {selectedJobDetails.responsibilities.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              
              <button 
                className="apply-button"
                onClick={() => window.location.href = 'mailto:Divya@cognifiyar.com'}
              >
                Apply Now
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Careers;